// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false, 
     // url: 'http://localhost:51638/api/v1',
   url: 'https://api.timessquare.asia/api/v1',
   // TODO: replace with the real messaging microservice host once available
   messagingApiUrl: 'https://localhost:44328/api',
  messagingApiKey: 'e7e2ae1b01e04711843fe725aa146b007d70ca5c0af04aad891e2b247053414f',
   // messagingApiUrl: 'https://messaging.timessquare.asia/api',
};
 
